import { render } from "./OrgUnitRating.vue?vue&type=template&id=77d83078&scoped=true"
import script from "./OrgUnitRating.vue?vue&type=script&lang=js"
export * from "./OrgUnitRating.vue?vue&type=script&lang=js"

import "./OrgUnitRating.vue?vue&type=style&index=0&id=77d83078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d83078"]])

export default __exports__